// QR Builder type definitions — do not change field names (used in API persistence)
export const DEFAULT_SETTINGS = {
    dotStyle: 'square',
    // Scan-safe defaults (pretty presets can be applied by the UI)
    dotSize: 1.0,
    roundness: 0.28,
    merge: 0.35,
    padding: 24,
    eyeStyle: 'square',
    pupilStyle: 'square',
    pupilScale: 1.0,
    pupilRot: 0,
    // High contrast improves detection across camera apps
    eyeOut: '#111111',
    eyeIn: '#111111',
    fillType: 'solid',
    c1: '#111111',
    c2: '#111111',
    gradAngle: 135,
    bg: '#ffffff',
    frame: 'none',
    frameColor: '#6c47ff',
    frameTextColor: '#ffffff',
    frameLabel: 'SCAN ME',
    frameLabelSize: 0.05,
    logoEnabled: false,
    logoImg: null,
    logoSize: 0.22,
};
